// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome|Task
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import { IFhirElement, FhirElement } from './fhir/FhirElement';
import { IAddress, Address, AddressTypeEnum, AddressUseEnum } from './fhir/Address';
import { IQuantity, Quantity, QuantityComparatorEnum } from './fhir/Quantity';
import { IAge, Age } from './fhir/Age';
import { IAnnotation, Annotation } from './fhir/Annotation';
import { IAttachment, Attachment } from './fhir/Attachment';
import { IBackboneElement, BackboneElement } from './fhir/BackboneElement';
import { ICodeableConcept, CodeableConcept } from './fhir/CodeableConcept';
import { ICoding, Coding } from './fhir/Coding';
import { IContactDetail, ContactDetail } from './fhir/ContactDetail';
import { IContactPoint, ContactPoint, ContactPointSystemEnum, ContactPointUseEnum } from './fhir/ContactPoint';
import { IContributor, Contributor, ContributorTypeEnum } from './fhir/Contributor';
import { ICount, Count } from './fhir/Count';
import { IDataRequirement, IDataRequirementCodeFilter, IDataRequirementDateFilter, IDataRequirementSort, DataRequirement, DataRequirementCodeFilter, DataRequirementDateFilter, DataRequirementSort, DataRequirementSortDirectionEnum } from './fhir/DataRequirement';
import { IDistance, Distance } from './fhir/Distance';
import { IDosage, IDosageDoseAndRate, Dosage, DosageDoseAndRate } from './fhir/Dosage';
import { IDuration, Duration } from './fhir/Duration';
import { IExpression, Expression, ExpressionLanguageEnum } from './fhir/Expression';
import { IExtension, Extension } from './fhir/Extension';
import { IHumanName, HumanName, HumanNameUseEnum } from './fhir/HumanName';
import { IIdentifier, Identifier, IdentifierUseEnum } from './fhir/Identifier';
import { IMeta, Meta } from './fhir/Meta';
import { IMoney, Money } from './fhir/Money';
import { INarrative, Narrative, NarrativeStatusEnum } from './fhir/Narrative';
import { IParameterDefinition, ParameterDefinition, ParameterDefinitionUseEnum } from './fhir/ParameterDefinition';
import { IPeriod, Period } from './fhir/Period';
import { IRange, Range } from './fhir/Range';
import { IRatio, Ratio } from './fhir/Ratio';
import { IReference, Reference } from './fhir/Reference';
import { IRelatedArtifact, RelatedArtifact, RelatedArtifactTypeEnum } from './fhir/RelatedArtifact';
import { ISampledData, SampledData } from './fhir/SampledData';
import { ISignature, Signature } from './fhir/Signature';
import { ITiming, ITimingRepeat, Timing, TimingRepeat, TimingRepeatDayOfWeekEnum, TimingRepeatDurationUnitEnum, TimingRepeatPeriodUnitEnum } from './fhir/Timing';
import { ITriggerDefinition, TriggerDefinition, TriggerDefinitionTypeEnum } from './fhir/TriggerDefinition';
import { IUsageContext, UsageContext } from './fhir/UsageContext';
import { IResource, Resource } from './fhir/Resource';
import { IDomainResource, DomainResource } from './fhir/DomainResource';
import { ICarePlan, ICarePlanActivityDetail, ICarePlanActivity, CarePlan, CarePlanActivityDetail, CarePlanActivity, CarePlanActivityDetailKindEnum, CarePlanActivityDetailStatusEnum, CarePlanIntentEnum, CarePlanStatusEnum } from './fhir/CarePlan';
import { IEncounter, IEncounterStatusHistory, IEncounterClassHistory, IEncounterParticipant, IEncounterDiagnosis, IEncounterHospitalization, IEncounterLocation, Encounter, EncounterStatusHistory, EncounterClassHistory, EncounterParticipant, EncounterDiagnosis, EncounterHospitalization, EncounterLocation, EncounterStatusHistoryStatusEnum, EncounterLocationStatusEnum, EncounterStatusEnum } from './fhir/Encounter';
import { IGuidanceResponse, GuidanceResponse, GuidanceResponseStatusEnum } from './fhir/GuidanceResponse';
import { IObservation, IObservationReferenceRange, IObservationComponent, Observation, ObservationReferenceRange, ObservationComponent, ObservationStatusEnum } from './fhir/Observation';
import { IOperationOutcome, IOperationOutcomeIssue, OperationOutcome, OperationOutcomeIssue, OperationOutcomeIssueSeverityEnum } from './fhir/OperationOutcome';
import { IParameters, IParametersParameter, Parameters, ParametersParameter } from './fhir/Parameters';
import { IPatient, IPatientContact, IPatientCommunication, IPatientLink, Patient, PatientContact, PatientCommunication, PatientLink, PatientContactGenderEnum, PatientLinkTypeEnum, PatientGenderEnum } from './fhir/Patient';
import { IQuestionnaire, IQuestionnaireItemEnableWhen, IQuestionnaireItemAnswerOption, IQuestionnaireItemInitial, IQuestionnaireItem, Questionnaire, QuestionnaireItemEnableWhen, QuestionnaireItemAnswerOption, QuestionnaireItemInitial, QuestionnaireItem, QuestionnaireItemEnableWhenOperatorEnum, QuestionnaireItemEnableBehaviorEnum, QuestionnaireItemTypeEnum, QuestionnaireStatusEnum } from './fhir/Questionnaire';
import { IQuestionnaireResponse, IQuestionnaireResponseItemAnswer, IQuestionnaireResponseItem, QuestionnaireResponse, QuestionnaireResponseItemAnswer, QuestionnaireResponseItem, QuestionnaireResponseStatusEnum } from './fhir/QuestionnaireResponse';
import { IServiceRequest, ServiceRequest, ServiceRequestIntentEnum, ServiceRequestPriorityEnum, ServiceRequestStatusEnum } from './fhir/ServiceRequest';
import { ITask, Task, TaskIntentEnum, TaskStatusEnum } from './fhir/Task';

/**
 * Resource binding for generic use.
 */
type IFhirResource = 
ICarePlan 
|IDomainResource 
|IEncounter 
|IGuidanceResponse 
|IObservation 
|IOperationOutcome 
|IParameters 
|IPatient 
|IQuestionnaire 
|IQuestionnaireResponse 
|IResource 
|IServiceRequest
|ITask;


/**
 * Resource binding for generic use.
 */
type FhirResource = 
CarePlan 
|DomainResource 
|Encounter 
|GuidanceResponse 
|Observation 
|OperationOutcome 
|Parameters 
|Patient 
|Questionnaire 
|QuestionnaireResponse 
|Resource 
|ServiceRequest
|Task;

/**
 * Factory creator for FHIR Resources
 */
function fhirResourceFactory(source:any) : FhirResource|null {
  switch (source["resourceType"]) {
    case "CarePlan": return new CarePlan(source);
    case "DomainResource": return new DomainResource(source);
    case "Encounter": return new Encounter(source);
    case "GuidanceResponse": return new GuidanceResponse(source);
    case "Observation": return new Observation(source);
    case "OperationOutcome": return new OperationOutcome(source);
    case "Parameters": return new Parameters(source);
    case "Patient": return new Patient(source);
    case "Questionnaire": return new Questionnaire(source);
    case "QuestionnaireResponse": return new QuestionnaireResponse(source);
    case "Resource": return new Resource(source);
    case "ServiceRequest": return new ServiceRequest(source);
    case "Task": return new Task(source);
    default: return null;
  }
}
/**
 * Factory creator for strict FHIR Resources
 */
function fhirResourceFactoryStrict(source:any) : FhirResource|null {
  switch (source["resourceType"]) {
    case "CarePlan": return CarePlan.fromStrict(source);
    case "DomainResource": return DomainResource.fromStrict(source);
    case "Encounter": return Encounter.fromStrict(source);
    case "GuidanceResponse": return GuidanceResponse.fromStrict(source);
    case "Observation": return Observation.fromStrict(source);
    case "OperationOutcome": return OperationOutcome.fromStrict(source);
    case "Parameters": return Parameters.fromStrict(source);
    case "Patient": return Patient.fromStrict(source);
    case "Questionnaire": return Questionnaire.fromStrict(source);
    case "QuestionnaireResponse": return QuestionnaireResponse.fromStrict(source);
    case "Resource": return Resource.fromStrict(source);
    case "ServiceRequest": return ServiceRequest.fromStrict(source);
    case "Task": return Task.fromStrict(source);
    default: return null;
  }
}

export {
  type IFhirElement, FhirElement, 
  type IAddress, Address, AddressTypeEnum, AddressUseEnum, 
  type IQuantity, Quantity, QuantityComparatorEnum, 
  type IAge, Age, 
  type IAnnotation, Annotation, 
  type IAttachment, Attachment, 
  type IBackboneElement, BackboneElement, 
  type ICodeableConcept, CodeableConcept, 
  type ICoding, Coding, 
  type IContactDetail, ContactDetail, 
  type IContactPoint, ContactPoint, ContactPointSystemEnum, ContactPointUseEnum, 
  type IContributor, Contributor, ContributorTypeEnum, 
  type ICount, Count, 
  type IDataRequirement, type IDataRequirementCodeFilter, type IDataRequirementDateFilter, type IDataRequirementSort, DataRequirement, DataRequirementCodeFilter, DataRequirementDateFilter, DataRequirementSort, DataRequirementSortDirectionEnum, 
  type IDistance, Distance, 
  type IDosage, type IDosageDoseAndRate, Dosage, DosageDoseAndRate, 
  type IDuration, Duration, 
  type IExpression, Expression, ExpressionLanguageEnum, 
  type IExtension, Extension, 
  type IHumanName, HumanName, HumanNameUseEnum, 
  type IIdentifier, Identifier, IdentifierUseEnum, 
  type IMeta, Meta, 
  type IMoney, Money, 
  type INarrative, Narrative, NarrativeStatusEnum, 
  type IParameterDefinition, ParameterDefinition, ParameterDefinitionUseEnum, 
  type IPeriod, Period, 
  type IRange, Range, 
  type IRatio, Ratio, 
  type IReference, Reference, 
  type IRelatedArtifact, RelatedArtifact, RelatedArtifactTypeEnum, 
  type ISampledData, SampledData, 
  type ISignature, Signature, 
  type ITiming, type ITimingRepeat, Timing, TimingRepeat, TimingRepeatDayOfWeekEnum, TimingRepeatDurationUnitEnum, TimingRepeatPeriodUnitEnum, 
  type ITriggerDefinition, TriggerDefinition, TriggerDefinitionTypeEnum, 
  type IUsageContext, UsageContext, 
  type IResource, Resource, 
  type IDomainResource, DomainResource, 
  type ICarePlan, type ICarePlanActivityDetail, type ICarePlanActivity, CarePlan, CarePlanActivityDetail, CarePlanActivity, CarePlanActivityDetailKindEnum, CarePlanActivityDetailStatusEnum, CarePlanIntentEnum, CarePlanStatusEnum, 
  type IEncounter, type IEncounterStatusHistory, type IEncounterClassHistory, type IEncounterParticipant, type IEncounterDiagnosis, type IEncounterHospitalization, type IEncounterLocation, Encounter, EncounterStatusHistory, EncounterClassHistory, EncounterParticipant, EncounterDiagnosis, EncounterHospitalization, EncounterLocation, EncounterStatusHistoryStatusEnum, EncounterLocationStatusEnum, EncounterStatusEnum, 
  type IGuidanceResponse, GuidanceResponse, GuidanceResponseStatusEnum, 
  type IObservation, type IObservationReferenceRange, type IObservationComponent, Observation, ObservationReferenceRange, ObservationComponent, ObservationStatusEnum, 
  type IOperationOutcome, type IOperationOutcomeIssue, OperationOutcome, OperationOutcomeIssue, OperationOutcomeIssueSeverityEnum, 
  type IParameters, type IParametersParameter, Parameters, ParametersParameter, 
  type IPatient, type IPatientContact, type IPatientCommunication, type IPatientLink, Patient, PatientContact, PatientCommunication, PatientLink, PatientContactGenderEnum, PatientLinkTypeEnum, PatientGenderEnum, 
  type IQuestionnaire, type IQuestionnaireItemEnableWhen, type IQuestionnaireItemAnswerOption, type IQuestionnaireItemInitial, type IQuestionnaireItem, Questionnaire, QuestionnaireItemEnableWhen, QuestionnaireItemAnswerOption, QuestionnaireItemInitial, QuestionnaireItem, QuestionnaireItemEnableWhenOperatorEnum, QuestionnaireItemEnableBehaviorEnum, QuestionnaireItemTypeEnum, QuestionnaireStatusEnum, 
  type IQuestionnaireResponse, type IQuestionnaireResponseItemAnswer, type IQuestionnaireResponseItem, QuestionnaireResponse, QuestionnaireResponseItemAnswer, QuestionnaireResponseItem, QuestionnaireResponseStatusEnum, 
  type IServiceRequest, ServiceRequest, ServiceRequestIntentEnum, ServiceRequestPriorityEnum, ServiceRequestStatusEnum, 
  type ITask, Task, TaskIntentEnum, TaskStatusEnum,
  type IFhirResource,
  type FhirResource,
  fhirResourceFactory,
  fhirResourceFactoryStrict,
}
